import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { useRef, useState } from "react";
import { Button, CircularProgress, Grid, TextField } from "@mui/material";
import axios from "axios";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import {
  getOrderStatus,
  getPaymentMethodByNumber,
  getTranscationTypeNameByNumber,
} from "../../../utils";
import moment from "moment";
import "./index.css";

const DownloadInvoice = () => {
  const agGridRef = useRef<AgGridReact | null>(null);
  const [msisdn, setmsisdn] = useState("");
  const [action, setAction] = useState(false);
  const [invoices, setInvoices] = useState<any[]>([]);
  const [actionDownload, setActionDownload] = useState(false);

  const handleGetInovices = async () => {
    setInvoices([]);
    toast.dismiss();
    if (msisdn.trim().length > 9) {
      setAction(true);
      requestInvoices();
    } else {
      toast.error("Please enter valid inputs.");
    }
  };

  const requestInvoices = async () => {
    await axiosInterceptorInstance
      .get(`/dashboard/DownloadInvoicesData?Msisdn=${msisdn.trim()}`)
      .then((res: any) => {
        const data = JSON.parse(res.data.body);
        console.log(data);
        if (data == null) {
          toast.error("MSISDN not found.");
        } else {
          if (data.Data.length > 0) {
            data.Data.map((item: any) => {
              item.BundleName = item.BundleName == "" ? "--" : item.BundleName;
              item.TransactionType = getTranscationTypeNameByNumber(
                item.TransactionType
              );
              item.PaymentMethodType = getPaymentMethodByNumber(
                item.PaymentMethodType
              );
              item.OrderStatus = getOrderStatus(item.OrderStatus);
              item.TransactionDate = moment(item.TransactionDate).format(
                "YYYY-MM-DD"
              );
            });
            setInvoices(data.Data);
          } else {
            toast.info("Record Not found");
          }
        }
      })
      .catch((error: any) => {
        toast.error(error.message);
      })
      .finally(() => {
        setAction(false);
      });
  };

  const downloadInvoice = async (data: any) => {
    setActionDownload(true);
    await fetch(
      `${process.env.REACT_APP_THM_API_URL}v1/payment/generateinvoice`,
      {
        method: "POST",
        headers: {
          "content-type": "application/json",
          accept: "application/octet-stream",
        },
        body: JSON.stringify({
          orderId: data.OrderID,
        }),
      }
    )
      .then((response: any) => {
        if (response.status != 200) {
          toast.dismiss();
          toast.error("Unable to download invoice");
          return;
        } else {
          return response.blob();
        }
      })
      .then((blob: any) => {
        console.log(blob);
        if (blob) {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.target = "_blank";
          link.download = `Invoice-${data.OrderID}.pdf`;
          link.click();
          URL.revokeObjectURL(link.href);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      })
      .finally(() => {
        setActionDownload(false);
      });
  };

  const ActionsCellRenderer: React.FC<{ data: any }> = ({ data }) => {
    return (
      <Button
        onClick={() => {
          downloadInvoice(data);
        }}
        className="dButton dButton2"
        variant="contained"
        style={{ height: "32px", textTransform: "none" }}
      >
        Download
      </Button>
    );
  };

  const columnDefs: ColDef[] = [
    {
      field: "TransactionDate",
      headerName: "Order Date",
      filter: true,
      resizable: true,
    },
    { field: "OrderID", headerName: "OrderID", filter: true, resizable: true },
    {
      field: "BundleName",
      headerName: "Bundle Name",
      filter: true,
      resizable: true,
    },
    {
      field: "TotalAmount",
      headerName: "Total Amount",
      filter: true,
      resizable: true,
    },
    {
      field: "TransactionId",
      headerName: "Transaction Id",
      filter: true,
      resizable: true,
    },
    {
      field: "TransactionType",
      headerName: "Transaction Type",
      filter: true,
      resizable: true,
    },
    {
      field: "PaymentMethodType",
      headerName: "Payment Type",
      filter: true,
      resizable: true,
    },
    {
      field: "OrderStatus",
      headerName: "Order Status",
      filter: true,
      resizable: true,
    },
    { headerName: "Invoice", cellRenderer: ActionsCellRenderer },
  ];

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        {actionDownload && (
          <div className="dimBG">
            <CircularProgress size={40} />
          </div>
        )}
        <h2 className="sectionTitle">Download Invoices</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <TextField
                className="formControl"
                label="MSISDN"
                variant="outlined"
                defaultValue={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4}>
              {!action && (
                <Button
                  onClick={handleGetInovices}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Search
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
      {invoices.length > 0 && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={invoices}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default DownloadInvoice;
